import * as actionTypes from "./actionTypes";
import { client } from "../../service/ApolloClient/ApolloClient";
import { MUTATION_REGISTER } from "../../service/ApolloClient/ApolloMutation";
import { authFail } from "./auth";
import errorValidationApollo from "../../utility/Forms/errorValidationApollo";

export const registerStart = () => {
  return {
    type: actionTypes.REGISTER_START,
  };
};

export const registerSuccess = (user_id, name, cellphone) => {
  return {
    type: actionTypes.REGISTER_SUCCESS,
    success: true,
    user_id: user_id,
    cellphone: cellphone,
    name: name,
  };
};

export const registerFail = (errors) => {
  return {
    type: actionTypes.REGISTER_FAIL,
    errors: errors,
  };
};

export const registerLoad = () => {
  return {
    type: actionTypes.REGISTER_LOAD,
    errors: null,
  };
};

export const registerCLEAR = () => {
  return {
    type: actionTypes.REGISTER_CLEAR,
  };
};

export const registerRequest = (Name, Cellphone, Password) => {
  return (dispatch) => {
    dispatch(registerStart());

    const registerData = {
      name: Name,
      cellphone: Cellphone,
      password: Password,
    };

    client
      .mutate({
        mutation: MUTATION_REGISTER,
        variables: registerData,
      })
      .then((result) => {
        let user = result.data.register;
        dispatch(registerSuccess(user.id, user.name, user.cellphone));
      })
      .catch((reason) => {
        dispatch(authFail(errorValidationApollo(reason)));
        return dispatch(registerFail(errorValidationApollo(reason)));
      });
  };
};
